<div class="reset-password">
  <a [routerLink]="link" class="reset-password__link">{{'Forgot your password?' | translate}}</a>
</div>
